import {
  SEND_NOTIFICATION,
  RECEIVE_NOTIFICATION,
  RECEIVE_NOTIFICATION_HISTORY,
  SUBSCRIBE_NOTIFICATION,
  UNSUBSCRIBE_NOTIFICATION,
} from "constants/actionTypes";

const INITIAL_STATE = {
  subscribed: false,
  receivedMeta: {},
  received: [],
  sent: [],
  seen: [],
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case SUBSCRIBE_NOTIFICATION:
      return {
        ...state,
        subscribed: true,
      };
    case UNSUBSCRIBE_NOTIFICATION:
      return {
        ...state,
        subscribed: false,
      };
    case SEND_NOTIFICATION:
      return {
        ...state,
        sent: [...state.sent, action.payload],
      };
    case RECEIVE_NOTIFICATION:
      return {
        ...state,
        receivedMeta: {
          ...state.receivedMeta,
          total: state.receivedMeta?.total + 1,
          lastReceivedTime: Date.now(),
        },
        received: [action.payload, ...state.received],
      };
    case RECEIVE_NOTIFICATION_HISTORY:
      return {
        ...state,
        receivedMeta: {
          ...state.receivedMeta,
          ...action.payload.receivedMeta,
          lastReceivedTime: Date.now(),
        },
        received: [...action.payload.received],
      };
    default:
      return state;
  }
}
